function positionSliderArrows() {
  // Only run on desktop (990px and above)
  if (window.innerWidth < 990) return;

  document.querySelectorAll('slider-component').forEach(function(slider) {
    const btnWrapper = slider.querySelector('.custom-slider-buttons--side');
    const firstCardInner = slider.querySelector('.card__inner');

    if (!btnWrapper || !firstCardInner) return;

    const imageHeight = firstCardInner.getBoundingClientRect().height;
    const sliderHeight = slider.getBoundingClientRect().height;

    const textAreaHeight = sliderHeight - imageHeight;
    const bottomOffset = textAreaHeight + (imageHeight / 2.1);

    btnWrapper.setAttribute(
      'style',
      `bottom: ${bottomOffset}px !important; top: unset !important;`
    );
  });
}

// On mobile, clear any style that may have been set
function resetSliderArrows() {
  if (window.innerWidth >= 990) return;

  document.querySelectorAll('slider-component').forEach(function(slider) {
    const btnWrapper = slider.querySelector('.custom-slider-buttons--side');
    if (!btnWrapper) return;
    btnWrapper.removeAttribute('style');
  });
}

window.addEventListener('load', function() {
  positionSliderArrows();
  setTimeout(positionSliderArrows, 50);
});

window.addEventListener('resize', function() {
  positionSliderArrows();
  resetSliderArrows();
});